import { QUIET_CARD_VIDEO_URL } from "@healthos/ui";

const QUIET_CARD_VIDEO_CACHE = "healthos-media-v1";
let quietCardVideoPreload: Promise<boolean> | null = null;

export function preloadQuietCardVideo(options: { timeoutMs?: number } = {}): Promise<boolean> {
  if (typeof window === "undefined" || typeof fetch !== "function") {
    return Promise.resolve(false);
  }

  quietCardVideoPreload ??= preloadVideo(QUIET_CARD_VIDEO_URL).then((ok) => {
    if (!ok) quietCardVideoPreload = null;
    return ok;
  });

  if (!options.timeoutMs || options.timeoutMs <= 0) {
    return quietCardVideoPreload;
  }

  return withTimeout(quietCardVideoPreload, options.timeoutMs);
}

async function preloadVideo(url: string): Promise<boolean> {
  try {
    const response = await fetch(url, { cache: "force-cache" });
    if (!response.ok) return false;

    const cacheCopy = response.clone();
    const blob = await response.blob();
    if (blob.size <= 0) return false;

    await writeCache(url, cacheCopy).catch(() => undefined);
    return true;
  } catch (err) {
    console.warn("[media-preload] quiet video preload failed:", err);
    return false;
  }
}

async function writeCache(url: string, response: Response): Promise<void> {
  if (!("caches" in window)) return;
  const cache = await window.caches.open(QUIET_CARD_VIDEO_CACHE);
  await cache.put(url, response);
}

function withTimeout(promise: Promise<boolean>, timeoutMs: number): Promise<boolean> {
  return new Promise((resolve) => {
    const timeoutId = window.setTimeout(() => resolve(false), timeoutMs);
    promise.then(resolve, () => resolve(false)).finally(() => window.clearTimeout(timeoutId));
  });
}
